import { FeatureUnavailable } from "@cynthai/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useAppCapabilities } from "@/core/hooks/use-app-capabilities";
import { isAuditMember } from "@/core/lib/access";
import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute("/_protected/auditor")({
  beforeLoad: ({ context, ...guard }) => {
    if (!isAuditMember(context.user)) {
      denyRouteAccess(guard, "audit_membership");
    }
  },
  component: AuditorLayout,
});

function AuditorLayout() {
  const appCapabilities = useAppCapabilities();

  if (!appCapabilities.fabric) {
    return <FeatureUnavailable />;
  }

  return <Outlet />;
}
